import { useEffect, useState } from "react";
import { Ticket, X } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";

// Popup al check-in: propone i coupon attivi del cliente da agganciare alla prenotazione.
// Il consumo avviene da solo perche' la prenotazione e' gia' IN.
export default function CheckinCouponModal({ res, onClose, onApplied }) {
  const [coupons, setCoupons] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/reservations/${res.id}/customer-coupons`)
      .then((r) => setCoupons(r.data || []))
      .catch(() => setCoupons([]));
  }, [res.id]);

  const apply = async (cc) => {
    setBusy(true);
    try {
      await api.patch(`/reservations/${res.id}/coupon`, { cc_id: cc.cc_id });
      toast.success(`Coupon "${cc.coupon_name}" applicato e utilizzato`);
      onApplied?.();
      onClose();
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-3"
      onClick={onClose} data-testid="checkin-coupon-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-4"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-display text-lg font-bold text-zinc-900">Coupon del cliente</h3>
            <p className="text-sm text-zinc-500 mt-0.5">
              {res.customer_name} ha dei coupon attivi. Il cliente vuole usarne uno per questa visita?
            </p>
          </div>
          <button onClick={onClose} data-testid="checkin-coupon-close"
            className="p-1.5 rounded-md text-zinc-400 hover:bg-zinc-100">
            <X size={18} />
          </button>
        </div>
        {coupons === null && <div className="text-sm text-zinc-400 py-4 text-center">Caricamento...</div>}
        {coupons !== null && coupons.length === 0 && (
          <div className="text-sm text-zinc-400 py-4 text-center" data-testid="checkin-coupon-empty">
            Nessun coupon attivo per questo cliente
          </div>
        )}
        <div className="space-y-2">
          {(coupons || []).map((cc) => (
            <div key={cc.cc_id} data-testid={`checkin-coupon-${cc.cc_id}`}
              className="flex items-center gap-3 border border-emerald-200 bg-emerald-50 rounded-lg p-3">
              <Ticket size={20} weight="bold" className="text-emerald-600 shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-zinc-900 truncate">{cc.coupon_name}</div>
                <div className="text-xs text-zinc-500">
                  {cc.code}{cc.valid_to ? ` · valido fino al ${cc.valid_to}` : ""}
                </div>
              </div>
              <button onClick={() => apply(cc)} disabled={busy}
                data-testid={`checkin-coupon-apply-${cc.cc_id}`}
                className="h-9 px-4 rounded-md bg-emerald-600 text-white text-xs font-bold hover:bg-emerald-700 active:scale-95 transition disabled:opacity-50">
                APPLICA
              </button>
            </div>
          ))}
        </div>
        <button onClick={onClose} data-testid="checkin-coupon-skip"
          className="w-full h-10 rounded-md border border-zinc-300 text-zinc-600 text-sm font-semibold hover:bg-zinc-50">
          Nessun coupon
        </button>
      </div>
    </div>
  );
}
